type Entries<T> = NonNullable<
    {
        [K in keyof T]: [K, T[K]];
    }[keyof T]
>[];

export function entries<T extends Record<string, any>>(obj: T): Entries<T> {
    return Object.entries(obj) as Entries<T>;
}